
import { createRouter, createWebHistory } from "vue-router";
const MaintenanceComponent = () => import("@/shared/components/maintenance/Maintainence.vue");

import CricketFightRoutes from "@/modules/cricket-fight";
import SportsRoutes from "@/modules/sports";
import matkaRoutes from "@/modules/matka"
import NotificationsRoutes from "@/modules/notification"
import AccountRoutes from "@/modules/account";
import WalletRoutes from "@/modules/wallet";
import BonusRoutes from "@/modules/bonus";
import ReferAndEarnRoutes from "@/modules/refer-and-earn";
import BetsRoutes from "@/modules/bets";
import AuthRoutes from "@/modules/authorization";
import VirtualRoutes from '@/modules/virtual-sport';
import RaceRoutes from "@/modules/race";
import CasinoSlotRoutes from "@/modules/casino-slot";
import OthersRoutes from "@/modules/others";
import Login from '@/modules/authorization/components/Login.vue';
import SignUp from '@/modules/authorization/components/SignUp.vue';
import ForgetPassword from '@/modules/authorization/components/ForgetPassword.vue';
import Rules from '@/shared/components/rules/Rules.vue'
import ResponsibleGaming from "@/shared/components/footer/ResponsibleGaming.vue";
import NotFound from "../shared/components/no-data/404.vue";

const routes = [
    {
        path: "/",
        redirect: "/home",
    },
    {
        path: "/login",
        name: "Login",
        component: Login
    },
    {
        path: "/register",
        name: "SignUp",
        component: SignUp
    },
    {
        path: "/forgot-password",
        name: "ForgetPassword",
        component: ForgetPassword
    },
    {
        path: "/rules",
        name: "Rules",
        component: Rules
    },
    {
        path: "/responsiblegaming",
        name: "ResponsibleGaming",
        component: ResponsibleGaming
    },

    {
        path: "/maintenance",
        name: "Maintenance",
        component: MaintenanceComponent
      },

    SportsRoutes,
    AccountRoutes,
    matkaRoutes,
    NotificationsRoutes,
    WalletRoutes,
    BonusRoutes,
    ReferAndEarnRoutes,
    BetsRoutes,
    AuthRoutes,
    VirtualRoutes,
    RaceRoutes,
    CasinoSlotRoutes,
    OthersRoutes,
    CricketFightRoutes,
    { 
        path: '/:pathMatch(.*)*',
        name: 'NotFound', 
        component: NotFound 
    },   
];

export default createRouter({
    history: createWebHistory(),
    routes
});